interface PublicGlobalsProps {
  API_BASE_URL: string
  CDN_BASE_URL: string
  DATA_PRIVACY_MEDIA_URL: string
  INSTAGRAM_APP_ID: string
  INSTAGRAM_REDIRECT_URI: string
  STAGE: string
  UI_VERSION: string
  PDFTRON_LICENSE: string
}

// @ts-ignore
const PublicGlobals: PublicGlobalsProps = {
  PDFTRON_LICENSE:
    // eslint-disable-next-line max-len
    'ITG Automotive LLC:OEM:DealPoint::B+:AMS(20250509):F2CCA40307FA4AF37B313BC9B243182F4E6F0F87546E900ECF4DFA247C5E1781D6BEF5C7',
}

export default PublicGlobals
